import { jsx as _jsx } from "react/jsx-runtime";
import { Divider, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { makeGetListerHeadingInformation } from '../../redux/lister/selectors/ListerSelector';
export const ListerDividerContainer = ({ testId }) => {
    const listerHeadingInformation = useSelector(makeGetListerHeadingInformation());
    const { t } = useTranslation(I18N_NAMESPACES.product);
    return (_jsx(Divider, { children: _jsx(TextAlpha, { color: "subtle", testId: `${testId}-search-result-product-count`, children: `${listerHeadingInformation.itemCount} ${t('product.products').toLowerCase()}` }) }));
};
